import axios from '@/assets/js/axios.js'
import { v4 as uuidv4 } from 'uuid'
import { OTA_SERVICE_API, SAFETY_SERVICE_API, SN_API, VENDOR_API, MODEL_API } from './apis'
function getQueryParams (params) {
  const queryParams = {
    id: uuidv4(),
    timestamp: Date.parse(new Date()),
    version: '1.0',
    params: params,
    empty: false
  }
  return queryParams
}
// 获取产品列表
export function getPoductList (params) {
  return axios({
    url: OTA_SERVICE_API.PRODUCT_LIST,
    method: 'post',
    data: params
  })
}
// 固件升级列表
export function getFirmwareList (params) {
  return axios({
    url: OTA_SERVICE_API.FIRMWARE_LIST,
    method: 'post',
    data: params
  })
}
// 新增固件
export function addFirmware (params) {
  return axios({
    url: OTA_SERVICE_API.ADD_FIRMWARE,
    method: 'post',
    data: params
  })
}
// 删除固件
export function deleteFirware (params) {
  return axios({
    // url: '/ota-service/v1/ota/upgrade/firmware/delete',
    url: OTA_SERVICE_API.DELETE_FIRMWARE,
    method: 'post',
    data: params
  })
}
// 验证固件/批量升级
export function add (params) {
  return axios({
    url: OTA_SERVICE_API.Add_STRATEGY,
    method: 'post',
    data: params
  })
}
// 升级策略验证
export function isExistStrategy (params) {
  return axios({
    url: OTA_SERVICE_API.ISEXISTSTRATEGY,
    method: 'post',
    data: params
  })
}
//  上传固件
export function upLoadFile (params) {
  return axios({
    url: OTA_SERVICE_API.UPLOAD_PATH,
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
// 批量上传
export function importFile (params) {
  return axios({
    url: OTA_SERVICE_API.IMPORT,
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
// -----------------------------固件详情页-------------------------------------------------
// 获取批次管理列表
export function getStrategyByFirmwareId (params) {
  return axios({
    url: OTA_SERVICE_API.GET_STRATEGY_BY_FIRMWAREID,
    method: 'post',
    data: params
  })
}
// 产品版本
export function getVersion (params) {
  return axios({
    url: OTA_SERVICE_API.PRODUCT_VERSION,
    method: 'post',
    data: params
  })
}
// 通过固件ID获取设备管理列表
export function getDeviceByFirmwareId (params) {
  return axios({
    url: OTA_SERVICE_API.GET_DEVICE_BY_FIRMWAREID,
    method: 'post',
    data: params
  })
}

// 获取模块id根据productKey
export function getModule (params) {
  return axios({
    url: OTA_SERVICE_API.GET_MODULES,
    method: 'post',
    data: params
  })
}

// 获取版本号列表
export function getVersions (params) {
  return axios({
    url: OTA_SERVICE_API.GET_VERSIONS_LIST,
    method: 'post',
    data: params
  })
}

// 获取模块id根据productKey
export function getDevices (params) {
  return axios({
    url: OTA_SERVICE_API.GET_DEVICES,
    method: 'post',
    data: params
  })
}
export function progressStatus (params) {
  return axios({
    url: OTA_SERVICE_API.PROGRESS_STATUS,
    method: 'post',
    data: params
  })
}
// --------------------------批次管理页------------------------------

export function cancelUpgrade (params) {
  return axios({
    url: OTA_SERVICE_API.STRATEGY_CANCLE_UPGRADE,
    method: 'post',
    data: params
  })
}

//  -----------------------固件信息------------------------

export function firmwareInfo (params) {
  return axios({
    url: OTA_SERVICE_API.FIRMWARE_DETAILS,
    method: 'post',
    data: params
  })
}

export function firmwareInfoEdit (params) {
  return axios({
    url: OTA_SERVICE_API.FIRMWARE_UPDATE,
    method: 'post',
    data: params
  })
}

// ---------------------------批次详情页-----------------------------------
// 通过批次ID获取设备管理列表
export function getDeviceByStrategyId (params) {
  return axios({
    url: OTA_SERVICE_API.GET_DEVICE_BY_STRATEGY_BY_ID,
    method: 'post',
    data: params
  })
}

// 取消升级
export function cancelUp (params) {
  return axios({
    url: OTA_SERVICE_API.DEVICE_CANCLE_UPGRADE,
    method: 'post',
    data: params
  })
}

// 重升级
export function reUpgrade (params) {
  return axios({
    url: OTA_SERVICE_API.DEVICE_REUPGRADE,
    method: 'post',
    data: params
  })
}

// 获取批次信息
export function strategyInfos (params) {
  return axios({
    url: OTA_SERVICE_API.STRATEGY_DETAILS,
    method: 'post',
    data: params
  })
}
//
export function statisticsDevice (params) {
  return axios({
    url: OTA_SERVICE_API.STRATEGY_STATISTICS_DEVICE,
    method: 'post',
    data: params
  })
}
// ---------------------------CA证书模块-----------------------------------

// 获取注册证书列表
export function certList (params) {
  return axios({
    url: SAFETY_SERVICE_API.CERT_QUERY_LIST,
    method: 'post',
    data: params
  })
}

// 获取证书详情
export function certInfo (params) {
  return axios({
    url: SAFETY_SERVICE_API.REGISCERT_INFO,
    method: 'post',
    data: getQueryParams(params)
  })
}

// 获取证书绑定列表详情
export function bindCertInfo (params) {
  return axios({
    url: SAFETY_SERVICE_API.BINDCERT_INFO,
    method: 'post',
    data: getQueryParams(params)
  })
}

// 获取证书绑定列表项的详情数据
export function queryCertsInfo (params) {
  return axios({
    url: SAFETY_SERVICE_API.CERT_INFO,
    method: 'post',
    data: getQueryParams(params)
  })
}

// csv模板
export function csvTemplate (successCalllback, failCallBack, fileName) {
  return axios({
    url: SAFETY_SERVICE_API.DOWNLOAD_TEMPLATE,
    method: 'post'
  })
}

// 设备的csv模板
export function deviceCsvTemplate (params, successCalllback, failCallBack, fileName) {
  return axios({
    url: SAFETY_SERVICE_API.CERT_DOWNLOAD,
    method: 'post',
    data: {
      params: params
    }
  })
}

// 注册证书，模拟整个表单提交
export function regisCert (formData) {
  formData.append('id', uuidv4())
  formData.append('timestamp', Date.parse(new Date()))
  formData.append('version', '1.0')
  return axios({
    url: SAFETY_SERVICE_API.CERT_REGIS,
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 绑定证书，模拟整个表单提交
export function bindCert (formData) {
  formData.append('id', uuidv4())
  formData.append('timestamp', Date.parse(new Date()))
  formData.append('version', '1.0')
  return axios({
    url: SAFETY_SERVICE_API.CERT_BIND,
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 删除证书
export function delCertificate (params) {
  return axios({
    url: SAFETY_SERVICE_API.CERT_DELETE,
    method: 'post',
    data: getQueryParams(params)
  })
}

// VENDOR
export function vendorAdd (params) {
  return axios({
    url: VENDOR_API.VENDOR_ADD,
    method: 'post',
    data: getQueryParams(params)
  })
}
export function vendorList (params) {
  return axios({
    url: VENDOR_API.VENDOR_LIST,
    method: 'post',
    data: getQueryParams(params)
  })
}
export function vendorDelete (params) {
  return axios({
    url: VENDOR_API.VENDOR_DELETE,
    method: 'post',
    data: getQueryParams(params)
  })
}

export function vendorGet (params) {
  return axios({
    url: VENDOR_API.VENDOR_GET,
    method: 'post',
    data: getQueryParams(params)
  })
}

export function vendorUpdate (params) {
  return axios({
    url: VENDOR_API.VENDOR_UPDATE,
    method: 'post',
    data: getQueryParams(params)
  })
}


// model
export function modelAdd (params) {
  return axios({
    url: MODEL_API.MODEL_ADD,
    method: 'post',
    data: getQueryParams(params)
  })
}
export function modelList (params) {
  return axios({
    url: MODEL_API.MODEL_LIST,
    method: 'post',
    data: getQueryParams(params)
  })
}
export function modelDelete (params) {
  return axios({
    url: MODEL_API.MODEL_DELETE,
    method: 'post',
    data: getQueryParams(params)
  })
}

export function modelGet (params) {
  return axios({
    url: MODEL_API.MODEL_GET,
    method: 'post',
    data: getQueryParams(params)
  })
}

export function modelUpdate (params) {
  return axios({
    url: MODEL_API.MODEL_UPDATE,
    method: 'post',
    data: getQueryParams(params)
  })
}

// SN 管理模块
export function snList (params) {
  return axios({
    url: SN_API.SN_LIST,
    method: 'post',
    data: getQueryParams(params)
  })
}

export function snAdd (params) {
  return axios({
    url: SN_API.SN_ADD,
    method: 'post',
    data: getQueryParams(params)
  })
}

export function snDel (params) {
  return axios({
    url: SN_API.SN_DEL,
    method: 'post',
    data: getQueryParams(params)
  })
}

// 历史查询接口
export function snFileList (params) {
  return axios({
    url: SN_API.SN_FILE_LIST,
    method: 'post',
    data: getQueryParams(params)
  })
}
// 上传接口
export function snUpLoadFile (params) {
  return axios({
    url: SN_API.SN_FILE,
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
